<script setup lang="ts">
import { ref } from 'vue';
import LoadingCard from '../LoadingCard.vue';

defineExpose({ focus });

withDefaults(
  defineProps<{
    size?: string;
    align?: 'left' | 'center';
    loading?: boolean;
    processing?: boolean;
  }>(),
  {
    size: 'lg',
    align: 'center',
    loading: false,
    processing: false,
  }
);

const button = ref<HTMLElement | null>(null);

function focus() {
  button.value?.focus();
}
</script>

<template>
  <button v-bind="{ size, align, ...$attrs }" ref="button">
    <span :class="{ invisible: loading }">
      <slot />
    </span>

    <span v-if="loading" class="absolute">
      <LoadingCard class="text-white" width="32" />
    </span>
  </button>
</template>
